// extracted by mini-css-extract-plugin
export default {"imageWrapper":"WQ-z","hovered":"XQ-z","hoverImage":"YQ-z","mainImage":"ZQ-z","imageNoBackground":"_Q-z","fullSizeImage":"aR-z"};